"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrustpilotBusinessUnitName = void 0;
var TrustpilotBusinessUnitName;
(function (TrustpilotBusinessUnitName) {
    TrustpilotBusinessUnitName["AVEN"] = "AVEN";
    TrustpilotBusinessUnitName["FIGURE"] = "FIGURE";
    TrustpilotBusinessUnitName["ROCKET"] = "ROCKET";
})(TrustpilotBusinessUnitName || (exports.TrustpilotBusinessUnitName = TrustpilotBusinessUnitName = {}));
